// extracted by mini-css-extract-plugin
var _1 = "O6R3FyrYYW1qgWMpjmYm";
export { _1 as "test" }
